import BaseModel from './BaseModel';
import AutoScreeningJob from './AutoScreeningJob';

export default class Model extends BaseModel {
  constructor(data = {}) {
    super(Model, data);
    this.id = data.id;
    this.name = data.name;
    this.uri = data.uri;
    this.autoScreeningJob = new AutoScreeningJob(
      data.autoScreeningJob
    );
    this.modelCreatedAt = data.modelCreatedAt;
  }
}
